import qs from 'query-string';
import { get, post, put, del } from './baseApi';

export const FarmApi = {
    fetch: (query, options) => get(`/farms?${qs.stringify(query)}`, options),
    fetchById: (id) => get(`/farms/${id}`),
    create: (data) => post('/farms', data),
    update: (id, data) => put(`/farms/${id}`, data),
    delete: (id) => del(`/farms/${id}`),
};
